import type { ExistingOrder } from '@einwert/valuation-api-client'
import { useFetchCurrentCustomer, useGetCurrentCustomer, usePatchCustomer } from 'ClientPortal/src/api/Queries/customers'
import { useGetMultiAssetValueOverview } from 'ClientPortal/src/api/Queries/value-overview'
import { useCreateOrder } from 'ClientPortal/src/api/Queries/orders'
import { useIamContext } from 'ClientPortal/src/context/IAmContext'
import { useOptionalTypedParams } from 'ClientPortal/src/router/useTypedParams'
import { useGetCustomerUsers } from 'ClientPortal/src/api/Queries/users'

export function useCreateOrderPage({ onCreateSuccess }: { onCreateSuccess: (data: ExistingOrder) => void }) {
    const { user, isUserPending } = useIamContext()
    const { assetId } = useOptionalTypedParams(['assetId'])
    const { customer, isCustomerInitialLoading } = useGetCurrentCustomer()

    const assetsData = useGetMultiAssetValueOverview({ throwOnError: false, retry: false })
    const { customerUsers, isCustomerUsersPending } = useGetCustomerUsers()

    const getPrefilledMandators = () => customer?.company_profile?.mandators || []
    const getPrefilledCostCenters = () => customer?.company_profile?.cost_centers || []

    const { patchCustomer, isPatchingCustomer } = usePatchCustomer({ customerId: customer?.uuid })
    const { createOrderMutate, isCreateOrderError, isCreatingOrder } = useCreateOrder({ onSuccess: onCreateSuccess })
    const { fetchCustomer, isFetchingCustomer } = useFetchCurrentCustomer()

    return {
        customer,
        user,
        getPrefilledCostCenters,
        getPrefilledMandators,
        isMandatorsInitialLoading: isCustomerInitialLoading,
        isCostCentersInitialLoading: isCustomerInitialLoading,
        customerUsers,
        isCustomerUsersPending,
        isUserPending,
        createOrderMutate,
        isCreateOrderError,
        isCreatingOrder,
        assetsData,
        patchCustomer,
        isPatchingCustomer,
        fetchCustomer,
        isFetchingCustomer,
        assetId,
    }
}
